var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('loader'),(_vm.publicRoute)?_c('router-view'):_vm._e(),(!_vm.publicRoute)?_c('AdminTemplate'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }